<div class="overview-container">
  <!-- Column Visibility Controls -->
  <div class="column-controls">
    <button class="btn btn-primary toggle-btn mb-1" (click)="toggleColumnPanel()">
      {{ showColumnPanel ? ("labels.hideColumnOptions" | translate) : ("labels.showColumnOptions" | translate) }}
    </button>

    @if(showColumnPanel) {
    <div class="column-panel">
         <div class="bulk-actions">
          <button class="bulk-btn" (click)="showAllColumns()">{{"contracts.buttons.showAll" | translate}}</button>
          <button class="bulk-btn" (click)="hideAllColumns()">{{"contracts.buttons.hideAll" | translate}}</button>
        </div>

      <div class="column-list">

        @for(column of columnVisibility; track column.field ) {
        <label class="column-item">
          <input type="checkbox" [checked]="column.visible" [disabled]="column.field === 'taskSmall.title' || column.field === 'actions'" (change)="toggleColumnVisibility(column.field)" />
          <span>{{ column.headerName }}</span>

        </label>
        <!-- xxxx contractTableTitles.actions should also be disable, or not be in the list. -->
        }

      </div>
    </div>
    }

  </div>

  <!-- The AG Grid component -->
  <ag-grid-angular
    style="width: 100%; height: 100%;"
    [rowData]="contractList"
    [columnDefs]="colDefs"
    [defaultColDef]="defaultColDef"
    [context]="gridContext"
    [pagination]="true"
    (gridReady)="onGridReady($event)"
    (rowDoubleClicked)="onRowClicked($event)"
    [suppressNoRowsOverlay]="true"
  />

  <router-outlet></router-outlet>
</div>